import { TableHead, SearchData } from "../../../../common/dataClass/Default"

/**搜索数据 */
class OrderSearchData extends SearchData{
  constructor() {
    super()
    /**店铺 */
    this.store = ''
    /**国家站点 */
    this.countrySite = ''
    /**订单编号 */
    this.orderId = ''
    /**订单日期 */
    this.orderDate = ''
  }
  /**搜索数据请求体 */
  get getSearchAxiosBody(){
    return {
      page: this.page,
      row: 10,
      saleStatus: 0,
      storeName: this.store? this.store : null,
      countryArea: this.countrySite? this.countrySite : null,
      textFilter: this.text? this.text : null
    }
  }
}

/**订单数量表头 */
class OrderTableHead extends TableHead{
  constructor(name, prop, width) {
    super(name, prop, width)
  }
}

class OrderNewModule{
  /**订单数量表头 */
  static NEWTABLEHEAD(){
    let arr = [
      new OrderTableHead('亚马逊订单编号', 'img', '200'),
      new OrderTableHead('订单日期', 'name', '100'),
      new OrderTableHead('店铺名称', 'storeName', '150'),
      new OrderTableHead('国家站点', 'countrySiteName', '150'),
      new OrderTableHead('配送城市', 'unitName', '150'),
      new OrderTableHead('州/省/直辖市<br>(或自治区)', 'stockPrice', '200'),
      new OrderTableHead('邮政编码', 'getSavePriceByTable', '80'),
      new OrderTableHead('Asin数量', 'getCostSummaryByTable', '120'),
      new OrderTableHead('商品税', 'getNetProfitOfGoodsByTable', '100'),
      new OrderTableHead('运费', 'getCostOfCommodityInvestmentByTable', '100'),
      new OrderTableHead('运费税', 'getCommodityCollectionByTable', '80'),
      new OrderTableHead('订单金额<br>(本币)', 'getShowNumAndActualNumByTable', '120'),
      new OrderTableHead('订单金额<br>(¥)', 'disposalNum', '80'),
      new OrderTableHead('操作', 'operate', '100'),
    ]
    return arr
  }
}

export { OrderSearchData, OrderNewModule }
